<template>
  <div class="c-nav" v-bind="$attrs">
    <div>
      <div
        v-if="showBack"
        class="c-nav__back"
        role="button"
        tabindex="0"
        @click="emit('back')"
        @keydown.enter="emit('back')"
      >
        戻る
      </div>
    </div>
    <div class="c-nav__title">
      <slot></slot>
    </div>
    <div></div>
  </div>
</template>

<script setup lang="ts">
import '../../styles/bonatitan/_global.scss'
import '../../styles/bonatitan/_variables.scss'
import '../../styles/bonatitan/c-nav.scss'

defineProps<{
  // ヘッダ左上に戻るボタン(矢印付き)を表示する。押下で back を emit。
  showBack?: boolean
}>()

const emit = defineEmits<{
  (e: 'back'): void
}>()
</script>
